import classNames from 'classnames'
import React from 'react'

export default function LoadingAnimation(props) {
  const className = classNames('loading-animation', props.className)
  return <div {...props} className={className} />
}
